import React from "react";

interface LocalizedTextCellProps {
  localizedText?: Record<string, string> | null;
  lang?: string | null;
}

export const LocalizedTextCell: React.FC<LocalizedTextCellProps> = ({
  localizedText,
  lang,
}) => {
  if (!localizedText) return <span>-</span>;

  const currentLang = lang || localStorage.getItem("language") || "ru";
  const text = localizedText[currentLang];

  return <div>{text || "-"}</div>;
};
